module.exports = __webpack_public_path__ + "static/img/48000.80cec77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48000.jpg
// module id = I1ey
// module chunks = 1